import React, { useState } from 'react';
import { Box } from 'grommet';
import SHDButton from '@ui/Button/SHDButton';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDText from '@ui/Text/SHDText';
import SHDInput from '@ui/Input/SHDInput';

import { useAdminDeleteUser } from '@hooks/useAdmin';

import type { DeleteUserProps } from '../../admin.types';

const DeleteUser: React.FC<DeleteUserProps> = ({ userId }) => {
  const [isSure, setIsSure] = useState<string>('');
  const { deleteUser, success, error } = useAdminDeleteUser();

  const handleDeleteButtonClick = async () => {
    await deleteUser(userId).then((response) => {
      if (response) {
        setTimeout(() => {
          window.location.href = '/admin';
        }, 3000);
      }
    });
  };

  return (
    <Box direction="column" gap="medium">
      <Box direction="column" gap="xxsmall">
        <SHDHeading level={4}>Delete User</SHDHeading>
        <SHDText>
          Completely deletes the user account. There&apos;s no going back! Type
          &quot;delete&quot; to confirm.
        </SHDText>
      </Box>
      <Box>
        {error && (
          <Box
            background="dk-red-alpha-10"
            border={{ side: 'all', color: 'dk-red-alpha-20' }}
            pad="medium"
            round="xsmall"
          >
            <SHDText color="dk-red-800">{error.message}</SHDText>
          </Box>
        )}

        {success && (
          <Box
            background="dk-green-alpha-10"
            border={{ side: 'all', color: 'shd-green-dark-alpha-30' }}
            pad="medium"
            round="xsmall"
          >
            <SHDText color="dk-green-800">{success.message}</SHDText>
          </Box>
        )}
      </Box>

      <SHDInput label="" onChange={(value) => setIsSure(value)} />
      <SHDButton
        primary
        label="Delete"
        disabled={!/delete/i.test(isSure)}
        onClick={handleDeleteButtonClick}
      />
    </Box>
  );
};

export default DeleteUser;
